import { connectorApi } from 'api/connector/api'
import { useHistory } from 'react-router-dom'
import { notifyError } from 'shared/errors'

export function useStopReloadSession() {
	const { push } = useHistory()

	const [signOutMember, mutationOptions] =
		connectorApi.useStopMemberSessionMutation()

	return [
		() =>
			signOutMember()
				.unwrap()
				.then(() => push('/team/members'))
				.catch(notifyError),
		mutationOptions
	] as const
}
